import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ContractReducer(state = initialState.contract, action: any) {
  switch (action.type) {
    case types.SAVE_CONTRACT_SUCCESS:
      return action.contract;
    default:
      return state;
  }
}
